import script from "./WorkflowUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowUploadFile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__